import { render, staticRenderFns } from "./TrainingCoursesList.vue?vue&type=template&id=33ce3ab0&scoped=true&"
import script from "./TrainingCoursesList.vue?vue&type=script&lang=js&"
export * from "./TrainingCoursesList.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCoursesList.vue?vue&type=style&index=0&id=33ce3ab0&lang=scss&scoped=true&"
import style1 from "./TrainingCoursesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ce3ab0",
  null
  
)

export default component.exports